<ng-container
  [ngTemplateOutlet]="button"
  [ngTemplateOutletContext]="{
    $implicit: 'arrow_previous',
    disabled: _disablePrevious,
    direction: _ScrollDirection.Previous,
    withMargin: true,
  }"
/>
<ng-container
  [ngTemplateOutlet]="button"
  [ngTemplateOutletContext]="{
    $implicit: 'arrow_next',
    disabled: _disableNext,
    direction: _ScrollDirection.Next,
    withMargin: false,
  }"
/>

<ng-template
  #button
  let-iconName
  let-disabled="disabled"
  let-direction="direction"
  let-withMargin="withMargin"
>
  <myre-action-button
    [class.margin]="withMargin"
    [iconName]="iconName"
    [disabled]="disabled"
    type="tertiary"
    color="blue"
    [onlyIcon]="true"
    [withDesktopIcon]="true"
    [preventDoubleClick]="false"
    (onClick)="_scroll(direction)"
    (mousedown)="!disabled ? _mouseDown(direction) : null"
    (mouseup)="_mouseUp()"
  />
</ng-template>
